import { handleActions } from 'redux-actions';
import cloneDeep from 'lodash/cloneDeep';
import update from 'immutability-helper';

import { fetchPassInfoList } from './actions';

export const initialState = {
  passInfoList: [],
};

export const reducer = handleActions(
  {
    [fetchPassInfoList]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          passInfoList: { $set: payload || [] },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          passInfoList: { $set: [] },
        });
      },
    },
  },
  cloneDeep(initialState)
);

export default reducer;
